import React, { Fragment } from "react";
const Door = () => {
  return (
    <Fragment>
      <section className="top-heading-dr">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div
                className="section-title-ca wow fadeInLeft"
                data-wow-delay="1.5s"
              >
                <h1>Door Delivery Services</h1>
                <a href="#" className="btn get-started-top btn-ps">
                  SIGNUP NOW
                </a>
              </div>
            </div>

            <div className="col-md-6 wow fadeInRight" data-wow-delay="1.5s">
              <div className="br-secimg">
                <img src="img/top-2.png"></img>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="service" className="section-padding">
        <div className="whole-wrap">
          <div className="container box_1170">
            <div className="br-par">
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by
                injected humour, or randomised words which don't look even
                slightly believable. If you are going to use a passage of Lorem
                Ipsum, you need to be sure there isn't anything embarrassing
                hidden in the middle of text. All the Lorem Ipsum generators on
                the Internet tend to repeat predefined chunks as necessary,
                making this the first true generator on the Internet. It uses a
                dictionary of over 200 Latin words, combined with a handful of
                model sentence structures, to generate Lorem Ipsum which looks
                reasonable. The generated Lorem Ipsum is therefore always free
                from repetition, injected humour, or non-characteristic words
                etc.
              </p>
            </div>

            <div className="tab-content">
              <div className="container tab-pane active" id="my_1">
                <div
                  className="section-title wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  <h2>Our Features</h2>
                </div>
                <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/cash-in-hand.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Cash on delivery</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/lock--v1.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Closed container</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.7s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/purchase-order.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Monthly report</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/security-checked.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Insuarance service</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/conference-call.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Courteous staff</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.8s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/last-24-hours.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Customer care 24/7</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/sms.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Notification at every stage</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/bullet-camera.png" />
                      </div>
                      <div className="icon-info">
                        <h5>CCTV surveillance</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.9s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/bank-card-back-side.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Paid, Topay &amp; Credit payment mode</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="mt-5">
                    <div
                      className="section-title wow fadeInUp"
                      data-wow-delay="1s"
                    >
                      <h2>How it works</h2>
                    </div>
                    <div
                      id="myCarousel"
                      className="carousel slide"
                      data-ride="carousel"
                    >
                      {/* <!-- Indicators --> */}
                      <ol className="carousel-indicators">
                        <li
                          data-target="#myCarousel"
                          data-slide-to="0"
                          className="active"
                        ></li>
                        <li data-target="#myCarousel" data-slide-to="1"></li>
                        <li data-target="#myCarousel" data-slide-to="2"></li>
                      </ol>

                      {/* <!-- Wrapper for slides --> */}
                      <div className="carousel-inner">
                        <div className="item active">
                          <img
                            src="img/shipper/h1-01.png"
                            className="img-responsive"
                            alt="Los Angeles"
                            style={{ width: "100%" }}
                          />
                        </div>

                        <div className="item">
                          <img
                            src="img/shipper/h2-01.png"
                            className="img-responsive"
                            alt="Chicago"
                            style={{ width: "100%" }}
                          />
                        </div>

                        <div className="item">
                          <img
                            src="img/shipper/h3-01.png"
                            alt="New york"
                            className="img-responsive"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            src="img/shipper/h4-01.png"
                            alt="New york"
                            className="img-responsive"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>

                      {/* <!-- Left and right controls --> */}
                      <a
                        className="left carousel-control"
                        href="#myCarousel"
                        data-slide="prev"
                      >
                        <span className="glyphicon glyphicon-chevron-left"></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="right carousel-control"
                        href="#myCarousel"
                        data-slide="next"
                      >
                        <span className="glyphicon glyphicon-chevron-right"></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="my_2">
                <div
                  className="section-title wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  <h2>Our Features</h2>
                </div>
                <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/cash-in-hand.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Cash on delivery</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/lock--v1.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Closed container</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.7s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/purchase-order.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Monthly report</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/security-checked.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Insuarance service</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/conference-call.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Courteous staff</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.8s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/last-24-hours.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Customer care 24/7</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/sms.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Notification at every stage</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/bullet-camera.png" />
                      </div>
                      <div className="icon-info">
                        <h5>CCTV surveillance</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                    <div
                      className="service-info wow fadeInUp"
                      data-wow-delay="0.9s"
                    >
                      <div className="icon">
                        <img src="https://img.icons8.com/bubbles/80/000000/bank-card-back-side.png" />
                      </div>
                      <div className="icon-info">
                        <h5>Paid, Topay &amp; Credit payment mode</h5>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod tempor incididunt ut labore et
                          dolore magna aliqua.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="mt-5">
                    <div
                      className="section-title wow fadeInUp"
                      data-wow-delay="1s"
                    >
                      <h2>How it works</h2>
                    </div>
                    <div
                      id="myCarousel"
                      className="carousel slide"
                      data-ride="carousel"
                    >
                      {/* <!-- Indicators --> */}
                      <ol className="carousel-indicators">
                        <li
                          data-target="#myCarousel"
                          data-slide-to="0"
                          className="active"
                        ></li>
                        <li data-target="#myCarousel" data-slide-to="1"></li>
                        <li data-target="#myCarousel" data-slide-to="2"></li>
                      </ol>

                      {/* <!-- Wrapper for slides --> */}
                      <div className="carousel-inner">
                        <div className="item active">
                          <img
                            src="img/shipper/h1-01.png"
                            className="img-responsive"
                            alt="Los Angeles"
                            style={{ width: "100%" }}
                          />
                        </div>

                        <div className="item">
                          <img
                            src="img/shipper/h2-01.png"
                            className="img-responsive"
                            alt="Chicago"
                            style={{ width: "100%" }}
                          />
                        </div>

                        <div className="item">
                          <img
                            src="img/shipper/h3-01.png"
                            alt="New york"
                            className="img-responsive"
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            src="img/shipper/h4-01.png"
                            alt="New york"
                            className="img-responsive"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>

                      {/* <!-- Left and right controls --> */}
                      <a
                        className="left carousel-control"
                        href="#myCarousel"
                        data-slide="prev"
                      >
                        <span className="glyphicon glyphicon-chevron-left"></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a
                        className="right carousel-control"
                        href="#myCarousel"
                        data-slide="next"
                      >
                        <span className="glyphicon glyphicon-chevron-right"></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row bk">
              <div
                className="col-md-6 img_1 col-sm-6 wow fadeInLeft"
                data-wow-delay="1.5s"
              >
                <img width="500px" src="img/shipper/bk-01.png" />
              </div>
              <div
                className="col-md-6 img_1 col-sm-6 wow fadeInLeft"
                data-wow-delay="1.5s"
              >
                <img width="500px" src="img/shipper/lc-01.png" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="carousel" className="testimonials">
        <div className="section-title wow fadeInUp" data-wow-delay="1s">
          <h2>Testimonials</h2>
        </div>
        <div className="container">
          <div className="row">
            <div
              className="col-md-8 col-md-offset-2 wow fadeInUp"
              data-wow-delay="1.5s"
            >
              <div className="quote">
                <i className="fa fa-quote-left fa-4x"></i>
              </div>
              <div
                className="carousel slide"
                id="fade-quote-carousel"
                data-ride="carousel"
                data-interval="3000"
              >
                {/* <!-- Carousel indicators --> */}
                <ol className="carousel-indicators">
                  <li data-target="#fade-quote-carousel" data-slide-to="0"></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="1"></li>
                  <li
                    data-target="#fade-quote-carousel"
                    data-slide-to="2"
                    className="active"
                  ></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="3"></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="4"></li>
                  <li data-target="#fade-quote-carousel" data-slide-to="5"></li>
                </ol>
                {/* <!-- Carousel items --> */}
                <div className="carousel-inner">
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/1.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                      <h6></h6>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/2.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                      <h6></h6>
                    </blockquote>
                  </div>
                  <div className="active item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/3.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/4.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/5.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                  <div className="item">
                    <div className="profile-circle">
                      <img
                        src="img/testimonials/6.jpg"
                        className="img-circle"
                      />
                    </div>
                    <blockquote>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit. Quidem, veritatis nulla eum laudantium totam
                        tempore optio doloremque laboriosam quas, quos eaque
                        molestias odio aut eius animi. Impedit temporibus nisi
                        accusamus.
                      </p>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className=" br-text wow lightSpeedIn" data-wow-delay="0.1s">
        <h3>Trusted By Thousands of Online Sellers</h3>
        <p>An all-in-one eCommerce Solution for your shipping needs</p>
        <a href="#" className="btn get-started btn-ps">
          SIGNUP NOW
        </a>
      </div>
    </Fragment>
  );
};

export default Door;
